import axios from 'axios'
import {
  LaundryConfigHoursColumn,
  LaundryConfigHoursDto,
  LaundryConfigHoursFilter,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL

export function getLaundryConfigHours(dto: LaundryConfigHoursFilter, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryConfigHoursColumn[]>>(
    `${BASEURL}/orderLote/getAllSettingsWashingTime/${page}`,
    dto,
  )
}

export function getLaundryConfigHoursById(dto: string | undefined) {
  return axios.get<ResponseObject<LaundryConfigHoursColumn>>(
    `${BASEURL}/orderLote/getSettingsWashingTimeById?id=${dto}`,
  )
}
export function createLaundryConfigHours(dto: LaundryConfigHoursDto) {
  return axios.post<ResponseCRUD>(`${BASEURL}/orderLote/createSettingsWashingTime`, dto)
}
export function updateLaundryConfigHours(dto: LaundryConfigHoursDto) {
  return axios.put<ResponseCRUD>(`${BASEURL}/orderLote/updateSettingsWashingTime`, dto)
}

export function deleteLaundryConfigHours(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/orderLote/deleteSettingsWashingTime?id=${dto}`)
}

export function getLaundryConfigHoursBySupplierId(id: string | undefined) {
  return axios.get<ResponseObject<any>>(
    `${BASEURL}/orderLote/getSettingsWashingTimeValueById?idProSite=${id}`,
  )
}
